module.exports = __webpack_public_path__ + "img/q-10-5@2x.4e1aa741.png";